import {useLocation, useNavigate, useParams} from "react-router-dom";
import {useEffect, useState} from "react";
import {isNullOrUndefined} from "../services/Validator";
import {kInternalRoutes} from "../constants/internalRoutes";
import LevelAContent from "../components/others/levelAScreen/LevelAContent";
import LevelAHeader from "../components/headers/levelAScreen/LevelAHeader";
import {Helmet} from "react-helmet";
import {buildHelmetTitle} from "../helpers/SeoHelper";
import LevelAScreenInfoDialog from "../components/dialogs/levelAScreen/LevelAScreenInfoDialog";

export default function LevelAScreen() {
    // Used in index.js to handle LevelA related content

    // PROPERTIES
    // ---- Navigation
    const { slug } = useParams()
    const location = useLocation()
    const from = location.state?.from ?? kInternalRoutes.courses
    const navigate = useNavigate()
    // ---- Functional
    const [isInfoModalOpen, setIsInfoModalOpen] = useState(false)
    const [isBrevetDisplay, setIsBrevetDisplay] = useState(false)

    // HOOKS
    // ---- Triggered at rendering : set Grades
    useEffect(() => {
        if (isNullOrUndefined(slug)) {
            navigate(from)
        }
        if (from === kInternalRoutes.brevet) {
            setIsBrevetDisplay(false)
        }
    }, [from, navigate, slug])

    // BUILD
    return (
        <div className="overflow-auto w-full h-[100svh] bg-backgroundLight3 flex flex-col justify-start items-center">
            {/** META */}
            <Helmet>
                <title>{buildHelmetTitle('Ummia - Savoir-faire')}</title>
                <meta name="description"
                      content="Consulte en détail chaque savoir-faire fondamental" />
            </Helmet>
            {/** MODAL */}
            <LevelAScreenInfoDialog open={isInfoModalOpen}
                                    handleClose={processModalClosing} />
            {/** CONTENT */}
            <div className={"w-full flex flex-col justify-start items-center"}>
                <LevelAHeader isBrevetDisplay={isBrevetDisplay}
                              handleBackToPreviousScreen={handleBackToPreviousScreen}
                              processModalOpening={processModalOpening} />
                <LevelAContent from={from}
                               slug={slug}
                               isBrevetDisplay={isBrevetDisplay} />
            </div>
        </div>
    );

    // METHODS
    // ---- NAV : Handle back to previous screen button destination
    function handleBackToPreviousScreen() {
        if (from === kInternalRoutes.brevet) {
            navigate(kInternalRoutes.brevet)
        } else {
            navigate(kInternalRoutes.courses)
        }
    }

    // ---- LOGIC : Open modal process
    function processModalOpening() {
        if (!isInfoModalOpen) {
            setIsInfoModalOpen(true);
        }
    }

    // ---- LOGIC : Close modal process
    function processModalClosing() {
        if (isInfoModalOpen) {
            setIsInfoModalOpen(false)
        }
    }
}